// @flow
// $FlowFixMe
import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import { QUERIES } from "@/enums/queries";
import { globalQueryClient } from "queries/queryClient";
import type { GoogleDriveSetting } from "types/google_integrations";

import { getGoogleDriveSettings } from "./services/loadGoogleDriveSettings";

export const useLoadGoogleDriveSettings = (
  options: any = {},
  // $FlowFixMe
): UseQueryResult<Array<GoogleDriveSetting>, Error> => {
  return useQuery({
    queryKey: [QUERIES.GOOGLE_DRIVE_SETTINGS.LIST],
    queryFn: () => {
      return getGoogleDriveSettings();
    },
    ...options,
  });
};

export const invalidateLoadGoogleDriveSettings = () => {
  globalQueryClient.invalidateQueries({
    queryKey: [QUERIES.GOOGLE_DRIVE_SETTINGS.LIST],
    exact: false,
  });
};
